
















import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import DateMethods from '@/mixins/DateMethods.vue';

@Component({
    inheritAttrs: false,
    components: {
        VueCtkDateTimePicker,
    },
})
export default class DatePicker extends Mixins(DateMethods) {
    @Prop({ default: null }) public locale: string;
    @Prop({ default: false }) public onlyDate: boolean;
    @Prop({ default: null }) public value: string;

    get dateString() {
        if (this.onlyDate) {
            return this.getUTCDateString(this.value);
        }
        return this.getLocalUTCOffsetString(this.value);
    }

    set dateString(value) {
        if (this.onlyDate) {
            this.$emit('input', this.getUTCDateString(value));
        } else {
            this.$emit('input', this.convertLocalTimeToISOString(value));
        }
    }
}
